import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import EmployeeReferralProgramPolicy from "./index";

const employeeReferralProgramPolicyRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Referral Program Policy",
		basePath: "employee-referral-program-policy",
		mainComponent: <EmployeeReferralProgramPolicy />,
	    layout: "/console",	   
	    subTitle:"Employee Referral Program Policy",
		level:5,
		moduleId: 0,
	})
]

export default employeeReferralProgramPolicyRoutes;